







































































import {Vue, Component, Watch} from 'vue-property-decorator'
import {DEFAULT_PAGINATION, Utils} from '@/app/infrastructures/misc'
import controller, {
  VoucherConfigHistoryBulkyParamsInterface,
} from '@/app/ui/controllers/VoucherConfigHistoryBulkyController'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import DateTimePickerV2 from '@/app/ui/components/DateTimePickerV2/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import {DataObject, HeaderObject} from '@/app/ui/components/DataTableV2/type'
import DataTableV2 from '@/app/ui/components/DataTableV2/index.vue'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import EmptyState from '@/app/ui/components/EmptyState/EmptyState.vue'
import {Dictionary} from 'vue-router/types/router'

export interface queriesInterface {
  sortBy: string
  page: string
  startDate: Date | null | string
  endDate: Date | null | string
  keyword: string
}

export interface parametersInterface {
  page: number
  perPage: number
  keyword: string
  tab: string
  date: {
    start: Date | null
    end: Date | null
  }
  sortBy: {
    label: string
    value: string
  }
}

@Component({
  name: 'VoucherConfigHistoryBulkyPage',
  components: {
    LoadingOverlay,
    TextInput,
    DateTimePickerV2,
    DropdownSelect,
    DataTableV2,
    PaginationNav,
    EmptyState,
  },
})
export default class VoucherConfigHistoryBulkyPage extends Vue {
  controller = controller
  sortOptions = [
    {label: 'Latest', value: 'DESC'},
    {label: 'Oldest', value: 'ASC'},
  ]
  parameters: parametersInterface = {
    page: 1,
    perPage: 10,
    keyword: '',
    tab: 'history-bulk',
    date: {
      start: null,
      end: null,
    },
    sortBy: this.sortOptions[0],
  }
  headers: Array<HeaderObject> = [
    {
      title: 'ID File',
      customStyle: {maxWidth: '120px', minWidth: '120px'},
    },
    {
      title: 'File Name',
    },
    {
      title: 'Email',
    },
    {
      title: 'Send Date',
    },
  ]

  created(): void {
    const queries = <queriesInterface>(<unknown>this.$route.query)
    let startDate = null
    let endDate = null
    const checkInvalidStartDate = queries.startDate
      ? new Date(queries.startDate)
      : null
    const checkInvalidEndeDate = queries.endDate
      ? new Date(queries.endDate)
      : null
    // to check Invalid Date
    if (
      checkInvalidStartDate?.toString() !== 'Invalid Date' &&
      checkInvalidEndeDate?.toString() !== 'Invalid Date'
    ) {
      if (queries.startDate !== '' && queries.endDate !== '') {
        if (
          <Date>checkInvalidStartDate >= this.minDate &&
          <Date>checkInvalidStartDate <= this.maxDate &&
          <Date>checkInvalidEndeDate <= this.maxDate &&
          <Date>checkInvalidEndeDate >= this.minDate
        ) {
          startDate = checkInvalidStartDate
          endDate = checkInvalidEndeDate
        }
      }
    }
    this.parameters = {
      sortBy:
        this.sortOptions.find((item) => item.value === queries.sortBy) ||
        this.sortOptions[0],
      page: Utils.alwaysNumber(queries.page) || 1,
      tab: 'history-bulk',
      perPage: DEFAULT_PAGINATION,
      date: {
        start: startDate,
        end: endDate,
      },
      keyword: queries.keyword,
    }

    this.fetchHistoryUploadBulky(true)
  }

  get maxDate(): Date {
    const maxDate = new Date()
    maxDate.setHours(7, 0, 0, 0)
    return maxDate
  }

  get minDate(): Date {
    const currentDate = new Date()
    const getTreeMonthAgo = currentDate.getMonth() - 3
    const setTreeMonthAgo = currentDate.setMonth(getTreeMonthAgo)
    const minDate = new Date(setTreeMonthAgo)
    minDate.setHours(7, 0, 0, 0)
    return minDate
  }

  get historyBulkData(): Array<DataObject[]> {
    return this.controller.dataHistoryUploadBulky.map((item) => {
      return [
        {
          value: item.id,
          customStyle: {maxWidth: '120px', minWidth: '120px'},
        },
        {
          value: item.filename,
        },
        {
          value: item.email,
        },
        {
          value: Utils.formatTimeZone(
            Utils.formatDate(item.createdAt, 'DD MMM YYYY, HH:mm:ss Z')
          ),
        },
      ]
    })
  }

  get params(): VoucherConfigHistoryBulkyParamsInterface {
    const {page, perPage, tab, keyword, sortBy} = this.parameters

    const newParameters = {
      page,
      perPage,
      tab,
      keyword,
      sortBy: sortBy,
    }

    return {
      ...newParameters,
      sortBy: this.parameters.sortBy.value,
      startDate: this.parameters.date.start
        ? new Date(Utils.formatDateWithIDLocale(
          new Date(this.parameters.date.start)?.toISOString()
        )).toISOString()
        : '',
      endDate: this.parameters.date.end
        ? new Date(Utils.formatDateWithIDLocale(
          new Date(this.parameters.date.end)?.toISOString()
        )).toISOString()
        : '',
    }
  }

  @Watch('params')
  onParamsChanged(val: Dictionary<string | (string | null)[] | null | undefined> | undefined): void {
    this.$router
      .replace({
        query: {...val},
      })
      .catch(() => false)
  }

  fetchHistoryUploadBulky(resetPage = false): void {
    if (resetPage) {
      this.parameters.page = 1
    }
    this.controller.getHistoryUploadBulky(this.params)
  }
}
